import React, { Component } from 'react'
import axios from 'axios'
import Layout from '../layout/Layout'
import { api } from '../utils/Api'
import Spinner from '../layout/Spinner'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import SendWriteUp from './SendWriteUp'

export default class EmployeeWriteUpPDF extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showModalEmail: false,
            showModalSms: false,
            pdf: '',
            loading: true,
            index: this.props.location.state.index
        }
    }

    /**
     * Get PDF employee write up
     */
    getPDFEmployeeWriteUp  = async () => {
        const url = api + `/employeewupdf/${this.props.match.params.id}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const body = {
                index: this.state.index
            }

            const { data } = await axios.post(url, body)
            this.setState({
                pdf: data,
                loading: false
            })
        } catch (err) {
            console.error(err)
            return null
        }
    }

    /**
     * Open and close email modal
     * @param {Event} e event of the modal
     */
    toggleModalEmail = (e) => {
        this.setState({
            showModalEmail: !this.state.showModalEmail
        })
    }

    /**
     * Open and close sms modal
     * @param {Event} e event of the modal
     */
    toggleModalSms = (e) => {
        this.setState({
            showModalSms: !this.state.showModalSms
        })
    }

    
    componentDidMount() {
        this.getPDFEmployeeWriteUp()
    }

    render() {

        return (
            <Layout
                title='Employee Write Up PDF'
                description='Employee Write Up'
                className="container col-md-12"
            >
                <Link onClick={this.toggleModalEmail}
                    to='#'
                    className="btn btn-primary"
                >
                    Send write up by email
                </Link>                
                <Link onClick={this.toggleModalSms}
                    to='#'
                    className="btn btn-success"
                    style={{marginLeft:20}}
                >
                    Send write up by SMS
                </Link>                
                <Modal show={this.state.showModalEmail} animation={false} onHide={this.toggleModalEmail}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Write Up to:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SendWriteUp 
                            employeeId={this.props.match.params.id} 
                            pcallback={this.toggleModalEmail}
                            isEmail={true}
                            index={this.state.index}
                        />
                    </Modal.Body>
                </Modal>  
                <Modal show={this.state.showModalSms} animation={false} onHide={this.toggleModalSms}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Write Up to:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SendWriteUp 
                            employeeId={this.props.match.params.id} 
                            pcallback={this.toggleModalSms}
                            isEmail={false}
                            index={this.state.index}
                        />
                    </Modal.Body>
                </Modal> 
                {
                    this.state.loading ? <Spinner/> : <iframe src={this.state.pdf} width='95%' style={{height: '90vh'}} />
                }
                
            </Layout>
        )
    }
}